/* Ссылки наружу: сайт агентства и запись на звонок.
 *
 * Конвенция не своя — она повторяет соседнее демо digital-yard
 * (frontend/src/lib/siteUrl.js). Две разные конвенции для одних и тех же двух
 * адресов разъедутся на первой же правке лендинга.
 */
import { DEFAULT_LANG, isLang } from '@/i18n';

const SITE_ORIGIN = 'https://brilliantflux.agency';

export const siteUrl = (lang) => `${SITE_ORIGIN}/${isLang(lang) ? lang : DEFAULT_LANG}`;

/* Слаги событий принадлежат лендингу агентства, здесь копия: импортировать их
 * из чужого репозитория неоткуда. Болгарский ведёт на русское событие
 * намеренно — meeting-bg на cal.com не существует (404), лендинг делает тот же
 * выбор. Не «чинить» в meeting-bg. */
const BOOKING_EVENT = {
  en: 'meeting-en',
  uk: 'meeting-uk',
  ru: 'meeting-ru',
  bg: 'meeting-ru',
};

export const bookingUrl = (lang) =>
  `https://cal.com/brilliantflux/${
    BOOKING_EVENT[Object.prototype.hasOwnProperty.call(BOOKING_EVENT, lang) ? lang : DEFAULT_LANG]
  }`;
